import type { DeckProject } from '../types'

interface ProjectDeleteDialogProps {
  project: DeckProject
  busy: boolean
  onClose: () => void
  onConfirm: () => void
}

export function ProjectDeleteDialog({ project, busy, onClose, onConfirm }: ProjectDeleteDialogProps) {
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && !busy && onClose()}>
      <section className="modal delete-dialog" role="alertdialog" aria-modal="true" aria-labelledby="project-delete-title">
        <span className="modal-kicker">Delete local project</span>
        <h2 id="project-delete-title">Delete “{project.name}”?</h2>
        <p className="delete-dialog-copy">This removes the project, its interrupted-save record, and all of its recovery copies from this browser. Export a project file first if you may need it later.</p>
        <div className="delete-impact">
          <div><strong>{project.rows.length}</strong><span>card{project.rows.length === 1 ? '' : 's'} removed</span></div>
          <div><strong>All</strong><span>local recovery copies removed</span></div>
        </div>
        <div className="modal-actions">
          <button type="button" className="button secondary" autoFocus disabled={busy} onClick={onClose}>Cancel</button>
          <button type="button" className="button danger" disabled={busy} onClick={onConfirm}>{busy ? 'Deleting…' : 'Delete project'}</button>
        </div>
      </section>
    </div>
  )
}

